<template>
  <div class="level">
      <div class="title">{{data.title}}</div>
      <div class="price">
          <div>
              <div class="price-num"> <div><i>€</i>{{data.price}}</div></div>
              <img src="@/static/img/insurance/9.png" alt="">
          </div>
      </div>
      <div class="level-list">
          <div class="level-item" v-for="(tag,index) in data.tags" :key="index">
              <div><div class="dot"></div><span>{{tag}}</span></div>
          </div>
      </div>
  </div>
</template>

<script>
export default {
    name: 'aon-level',
    props: {
        data: {
            type: Object,
            default: true
        }
    }
}
</script>

<style scpoed lang="less">
.level {
    background: #fff6f6;
    border-radius: 15px;
    position: relative;
    box-shadow: inset 0px 1px 20px -7px #bf0000;

    .title {
        color: #e11d24;
        background-color: #fccece;
        border-top-right-radius: 30px;
        /* border-radius: 25px; */
        border-top-left-radius: 15px;
        /* border-top-right-radius: 25px; */
        border-bottom-right-radius: 30px;
        position: absolute;
        padding: 15px 40px 15px 30px;
        font-weight: bold;
        font-size: 20px;
        font-family: '黑体';
    }
    .price {
        position: absolute;
        top: -10px;
        right: 15px;
        img {
            width: 100px;
            height: 70px;
            vertical-align: middle;
        }
        .price-num {
            width: 100%;
            position: absolute;
            top: 40%;
            left: 50%;
            transform: translate(-50%,-50%);
            color: #fff;
            font-size:20px;
            font-weight: bold;
            z-index: 1;
            display: flex;
            font-family: '黑体';
            
            >div {
                width: 100%;
                height: 50px;
                // line-height: 20px;
                display: flex;
                align-items: center;
                justify-content: center;
                 >i {
                // position: absolute;
                // top: 50%;
                font-size: 14px;
                font-style: normal;
                margin-top: 5px;
                // line-height: 60px;
                 }
            }
           
        }
    }
    .level-list {
        margin-top: 15px;
        padding: 60px 15px 20px 0;
        .level-item {

            display: flex;
            align-items: center;
            margin: 12px 0;
            font-size: 13px;
            >div {
                display: flex;
                // align-items: center;
                // justify-content: left;
            }
            // div::before {
            //     content: "";
            //     // display: block;
            //     float: left;
            //     width: 6px;
            //     height: 6px;
            //     margin: 6px 10px 0 15px;
            //     border-radius: 50%;
            //     background-color: #e11d24;
            //     // float: left;
            //     // line-height: 1.5;
            //     text-align: left;
            // }
            .dot {
                // flex: 1;
                // float: left;
                // width: 10px;
                margin: 6px 10px 0 15px;
            }
            .dot::before {
                     content: "";
                // display: block;
                float: left;
                width: 6px;
                height: 6px;
                border-radius: 50%;
                background-color: #e11d24;
            }
        }

    }
}
</style>